/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var AwardCupIcon20Solid = forwardRef('AwardCupIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1 3.4A1.4 1.4 0 0 1 2.4 2h15.2A1.4 1.4 0 0 1 19 3.4v2.5a3.9 3.9 0 0 1-3.589 3.888A5.755 5.755 0 0 1 11 12.95V16h3a1 1 0 1 1 0 2H6a1 1 0 1 1 0-2h3v-3.049a5.755 5.755 0 0 1-4.411-3.163A3.9 3.9 0 0 1 1 5.9V3.4Zm14.973 4.41A2.1 2.1 0 0 0 17.2 5.9V3.8H16v3.45c0 .19-.01.376-.027.56ZM2.8 3.8H4v3.45c0 .19.01.376.027.56A2.1 2.1 0 0 1 2.8 5.9V3.8Z" })));
});
